import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

const OptionListValueContext = createContext<string | undefined | null>(null);
const OptionListSetValueContext = createContext<((values: string) => void) | undefined | null>(
  null,
);
const OptionListValuesContext = createContext<string[] | undefined | null>(null);
const OptionListSetValuesContext = createContext<((values: string[]) => void) | undefined | null>(
  null,
);

export const OptionListProvider = ({
  children,
  value,
  values,
  setValue,
  setValues,
}: PropsWithChildren<{
  value?: string;
  values?: string[];
  setValue?: (value: string) => void;
  setValues?: (values: string[]) => void;
}>) => {
  return (
    <OptionListValueContext.Provider value={value}>
      <OptionListSetValueContext.Provider value={setValue}>
        <OptionListValuesContext.Provider value={values}>
          <OptionListSetValuesContext.Provider value={setValues}>
            {children}
          </OptionListSetValuesContext.Provider>
        </OptionListValuesContext.Provider>
      </OptionListSetValueContext.Provider>
    </OptionListValueContext.Provider>
  );
};

export const useOptionListValue = () => useContext(OptionListValueContext);
export const useOptionListSetValue = () => useContext(OptionListSetValueContext);
export const useOptionListValues = () => useContext(OptionListValuesContext);
export const useOptionListSetValues = () => useContext(OptionListSetValuesContext);
